import React from 'react';
import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

const Spinner = styled.span`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: ${spin} 0.9s linear infinite;
`;

export const ActiveStepSpinner: React.FC = () => (
  <Spinner aria-hidden>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <circle
        cx="10"
        cy="10"
        r="8"
        stroke="var(--color-text-dark, #042a2a)"
        strokeWidth="2"
        strokeLinecap="round"
        fill="none"
        strokeDasharray="10 30"
      />
    </svg>
  </Spinner>
);
